import config from 'config';
import { replace } from 'redux-little-router';
import { call, put, takeLatest } from 'redux-saga/effects';
import storageItems from 'constants/storageItems';
import { routeMap } from 'router';
import Storage from 'services/Storage';
import { logout } from '../../services/API';

import { actionTypes, logoutFailure, logoutSuccess } from './actions';
import REACT_CONFIG from 'REACT_CONFIG';
import { resetAppIsReady } from '../../../AppIsReadyCheckWrapper/redux/actions';

function* handleLogout(action) {
  const response = yield call(logout, action.payload);

  if (response.isOk) {
    yield Storage.removeItem(config.refreshTokenItemName);
    yield Storage.removeItem(storageItems.CONVERTATION_IS_DISABLED);
    yield Storage.removeItem(storageItems.PACKAGE_DESCRIPTION_DISABLED);
    yield Storage.removeItem(config.tokenItemName);
    yield put(resetAppIsReady());
    yield put(logoutSuccess());

    if (config.isDemoMode) {
      window.location = REACT_CONFIG.REACT_APP_PRIMARY_PATH;
    }

    yield put(replace(routeMap.login));
  } else {
    yield put(logoutFailure());
    //TODO: Mikheev - show message in UI
    alert('Ошибка выхода из личного кабинета, попробуйте позже');
  }
}

export default function* userSaga() {
  yield takeLatest(actionTypes.REQUEST_START, handleLogout);
}
